<template>
    <div class="boddy" ref="boddy">
        
        <Header :isScrolled="isScrolled"></Header>

        <div class="section imgone">
            <img :src="imageUrlone" alt="">
        </div>
        <div class="section contenttwo" ref="secondSection">
            <div class="divone" v-for="(item, index) in items" :key="index" :style="{ marginBottom: '7px' }">
                <div class="divonechild1">
                    <img :src="item.image" :alt="item.alt">
                </div>
                <div class="divonechild2">
                    <div class="titles ">{{ isEnglish ?item.titleen:item.title }}</div>
                    <div class="pscontent ">{{ isEnglish ?item.contenten:item.content }}</div>
                </div>
            </div>
        </div>

        <div class="section contentthree" >
            <img :src="imageUrlthree" alt="">
            <div class="titlethtee ">{{ isEnglish ?  titlethteen: titlethtee}}</div>
            <div class="contentthtee ">{{ isEnglish ? contentthteeen : contentthtee}}<br>

            </div>
        </div>

        <!-- 添加更多 section -->
  
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'

    import Bottom from "@/view/public/bottompc.vue";
    import axios from 'axios';
    import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
    import { mapActions, mapState } from 'vuex';
    export default {
        name: 'positioning',
     
        components:{
          
            Header,
           
            Bottom
        },
        data() {
            return {
                contentthtee:'以独特的品牌价值定位，致力于为广大进取者提供富有自信的商务旅行场景应用产品服务。\n' +
                    '以粤港澳大湾区为中心，致力于发展成为富有持续价值力的国际化商务旅行产品服务品牌。',
                    contentthteeen:'',
                titlethtee:'全球营销',
                titlethteen:'',
                isScrolled: false,
                imageUrlone: require('../../assets/pukipicsss-16.jpg'), // 动态传递的图片路径
                imageUrlthree: require('../../assets/pic-28-woldmap2-06.jpg'), // 动态传递的图片路径
                items: [
                    {
                        image: require('../../assets/pic-27-pic1-04.jpg'),
                        alt: '图片描述1',
                        title: '商务旅行场景应用产品服务',
                        titleen:'',
                        content: '谱祺，为商务旅行场景应用而生，立足于不同的商务旅行场景提供舒适和自信的产品和服务。\n\n' +
                            '我们坚持简约商务美学、创新设计、实用功能、可持续发展的产品理念，持续开发并革新产' +
                            '品，带给用户更好的商旅出行体验。',
                            contenten:''
                    },
                    {
                        image: require('../../assets/pic-27-pic2-05.jpg'),
                        alt: '图片描述2',
                        title: '进取之行',
                        titleen:'',
                        content: '谱祺，将进取精神融入到品牌基因，\n' +
                            '并以卓越的产品服务致敬每一场进取之行。\n\n\n\n',
                            contenten:''
                    },
                    
                ],

            };
        },
        computed: {
             // 从 Vuex 的 state 中获取 isEnglish 数据
             ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
             
        },

        mounted() {
            // 初次加载时立即调用一次 fetchData，确保使用当前的 isEnglish
            this.fetchData();
             

            
            window.addEventListener('wheel', this.handleScroll, { passive: false });
            this.$refs.boddy.addEventListener('scroll', this.debouncedHandleScroll);

            this.initObserver(); // 初始化观察器
        },
        beforeDestroy() {

            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {
            /**
             * 获取页面数据
             */
            async fetchData() {
                            try {
                            // 发起API请求
                            // const response = await axios.get(`${apiUrls.baseUrl}/website/api/`);
                            const response = await axios.get(`${apiUrls.baseUrl}/website/api/getpositioning`);
                             // 打印当前语言状态
                        //    console.log('Current isEnglish:', this.isEnglish);
                            
                            if (response.data && response.data.length > 0) {
                                const data = response.data[0]; // 假设只需要第一个对象的数据
                                
                               
                                 // 将 API 数据赋值给你的 Vue data() 对象
                                    this.contentthteeen = data.contentthteeen;
                                 
                              
                                    this.contentthtee = data.contentthteecn;
                                    this.titlethtee = data.titlethteecn;
                                    this.titlethteen=data.titlethteeen;
                               
                                
                                this.imageUrlone = `${apiUrls.devApi}${data.imageUrlone}`;
                                this.imageUrlthree = `${apiUrls.devApi}${data.imageUrlthree}`;

                                // 构造 items 列表
                                const imgContentImgArr = data.imgcontentimg.split(',');
                                const imgContentHcnArr = data.imgcontenthcn.split('；');
                                const imgContentHenArr = data.imgcontenthen.split('；');
                                const imgContentPcnArr = data.imgcontentpcn.split('；');
                                const imgContentPenArr = data.imgcontentpen.split('；');
                                this.items = imgContentImgArr.map((img, index) => ({
                                image: `${apiUrls.devApi}${img}`,
                                alt: `图片描述${index + 1}`,
                                title: imgContentPcnArr[index] || '标题缺失',
                                titleen:imgContentPenArr[index],
                                content: imgContentHcnArr[index] || '内容缺失',
                                contenten:imgContentHenArr[index]
                                }));
                            }
                            } catch (error) {
                            console.error('获取数据失败:', error);
                            }
                                },


            initObserver() {
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                // 只观察第二个 section
                // 只观察第二个 section
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.isScrolled = true; // 当第二个 section 进入视口时设置 isScrolled = true
                        }
                    });
                }, options);
                const secondSection = this.$refs.secondSection; // 监视第二个 section
                if (secondSection) {
                    observer.observe(secondSection);
                }

            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                    // 检查滚动位置并设置 isScrolled
                    if (scrollContainer.scrollTop === 0) {
                        this.isScrolled = false;
                    } else {
                        this.isScrolled = true;
                    }

                    let height;
                    height = window.innerHeight;
                // 设置固定的滚动距离为 97vh
                    const scrollDistance = window.innerHeight * 0.99; // 97vh
                    scrollContainer.scrollBy({

                        top: event.deltaY > 0 ? height : -height,
                        behavior: 'smooth'
                    });







                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
    /*第二个模块开始*/
    .contenttwo{
        height: 97vh;
        display: flex;
        flex-direction: column; /* 子元素垂直排列 */
        padding-right: 17rem;

    }
    .contenttwo .divone {
        flex: 1; /* 子元素平分父容器高度 */
        display: flex;

        flex-direction: row; /* 子元素水平排列 */


    }
    .contenttwo .divone:nth-child(1) {
        margin-top: -4rem; /* 向上移动第二个容器 */


    }
    .contenttwo .divone:nth-child(2) {
        margin-top: -8.5rem; /* 向上移动第二个容器 */
    }

    .divone .divonechild1, .divone .divonechild2 {
        flex: 1; /* 子容器左右平分 */

        width: 50%;

    }
    .divone .divonechild1{
        display: flex;
        justify-content: flex-end; /* 子容器靠近右侧 */
        align-items: center; /* 子容器垂直居中 */
        padding-right: 2rem; /* 给右侧添加 20px 的内边距 */
        padding-top: 4rem;
    }
    .divone .divonechild1 img{
        width: 55%;
    }
    .divone .divonechild2{
        display: flex;
        flex-direction: column; /* 子容器上下排列 */
        justify-content: center; /* 子容器垂直居中 */
        align-items: flex-start; /* 子容器靠右对齐 */
        padding-left: 1rem;
        padding-top: 4rem;
    }
    .divonechild2 .titles{
        margin-top: -2.8rem;
        font-size: 1.5rem;
        /*font-weight: bold;*/
        height: 3.3rem;


    }
    .divonechild2 .pscontent{
        margin-top: 2rem;
        white-space: pre-line; /* 允许使用换行符 */
        color: rgb(128, 128, 128);
        font-size: 1rem;
    }

    /*    第二个模块结束*/
/*    第一个模块图片开始*/
.imgone img{
    width: 100%;
    height: auto;
    margin-bottom: 15vh;
}
/*    第一个模块图片结束*/
/*    第三张图片模块开始*/
    .contentthree img{
        /*margin-top: 4rem;*/
        width: 100%;
        height: 97vh;
    }
    .contentthree{
        position: relative;
    }
    .contentthree .titlethtee{
        height: 97vh;
        position: absolute;
        top: 12rem;
        left: 20rem;
        font-size: 30px;
        font-weight: bold;
        color: white;
    }
    .contentthree .contentthtee{
        white-space: pre-line; /* 允许使用换行符 */
        position: absolute;
        top: 18rem;
        left: 20rem;
        color: white;
        width: 40rem;
    }
    /*第三张图片模块结束*/
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
    /*整体布局开始*/
    .boddy {
        height: 100vh;


        overflow-y: auto; /* 允许垂直滑动 */
    }
    /* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
    .boddy::-webkit-scrollbar {
        display: none;
    }

    /* 隐藏滚动条，适用于Firefox */
    .boddy {
        scrollbar-width: none; /* Firefox */
    }

    /* 隐藏滚动条，适用于Internet Explorer 和 Edge */
    .boddy {
        -ms-overflow-style: none; /* Internet Explorer 和 Edge */
    }

    /*整体布局结束*/
    /*内容部分开始*/
    .section{
        height: 97vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    /*内容部分结束*/
    .titlehed{
        display: none;

    }
    /*手机端样式开始*/
    @media screen and (max-width: 768px) {
        .boddy{
            width: 100vw;
        }
        .section{
            height: auto;
        }
        .imgone img{
            width: 100vw;
            height: auto;
        }
        .divone .divonechild1 img{
            width: 40vw;
            /* margin-left: 100rem; */
            height: auto;
        }
        .divonechild2 .titles{
            width: 40vw;
            font-size: 0.7rem;
            margin-top: 0;
            height: 2vh;
        }
        .divonechild2 .pscontent{
            width: 40vw;
            font-size: 0.1rem;
        }
        .contenttwo{
            padding: 0;
        }
        .divone{
                margin-top: -1vh!important;
                /* padding-top: 2vh; */
        }
        .divone .divonechild1{
            padding-top: 2vh;
        }
        .divone .divonechild2{
            padding-top: 0;
        }
        .contentthree img{
            width: 100vw;
            height: auto;
        }
        .contentthree .titlethtee{
            height: auto;
            font-size: 1rem;
           top:2vh;
           left: 0;
        }
        .contentthree .contentthtee{
            top: 6vh;
            left: 1vw;
            width: 97vw;
        }

    }
    /*手机端样式结束*/
</style>
